import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { LabelPrintConfigEndPoints } from 'src/app/constants/api-endpoints';
import { LabelPrintConfig } from 'src/app/models/auxiliary/label-print-config.model';
import { ApiService } from 'src/app/sections/common/services/api.service';


@Injectable({
  providedIn: 'root'
})
export class LabelPrintConfigService {

  labelPrintConfigsUrls = LabelPrintConfigEndPoints;

  constructor(private _apiService: ApiService) { }

  private returnResponse(response) {
    if (response._statusCode > 399) {
      throw (response);
    }
    return response;
  }

  getLabelPrintConfigList(): Observable<LabelPrintConfig> {
    return this._apiService.get(this.labelPrintConfigsUrls.get, true).pipe(
    map((response: any) => {
      return this.returnResponse(response);
    }));
  }

  saveLabelPrintConfig(labelPrintConfig: LabelPrintConfig): Observable<any> {
    return this._apiService.post(this.labelPrintConfigsUrls.save, labelPrintConfig, true, true).pipe(
    map((response: any) => {
      return this.returnResponse(response);
    }));
  }

  updateLabelPrintConfig(labelPrintConfig: LabelPrintConfig): Observable<any> {
    return this._apiService.put(this.labelPrintConfigsUrls.update + `/${labelPrintConfig.id.toString()}`,labelPrintConfig, true, true).pipe(
    map((response: any) => {
      return this.returnResponse(response);
    }));
  }

  deleteLabelPrintConfig(id: string): any {
    return this._apiService.delete(this.labelPrintConfigsUrls.delete, id, true).pipe(
    map((response: any) => {
      return this.returnResponse(response);
    }));
  }
}
